module.exports = __webpack_public_path__ + "simper.6fe6cd3e.png";